import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Button from '../../components/ui/Button';
import { ROTAS } from '@/routes/routePaths';

const PoliticaPrivacidadePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
      <div className="fixed inset-0 z-0">
        <img src="/Background-secao2.png" alt="Background" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/20"></div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="relative z-10 bg-background/95 backdrop-blur-sm p-6 rounded-lg shadow-2xl max-w-4xl w-full border border-primary overflow-hidden max-h-[90vh]"
      >
        <div className="absolute inset-0 z-0">
          <img src="/BG.png" alt="Background do card" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-black/5"></div>
        </div>

        <div className="relative z-20">
          <div className="flex justify-center mb-6">
            <Link to={'/'}>
              <img src={'/clube.png'} alt="Mr Tugas Logo" className='h-32 object-contain' />
            </Link>
          </div>

          <h2 className="text-3xl font-bold text-center text-primary mb-6">
            Política de Privacidade - Clube Mr Tugas
          </h2>

          <div className=" rounded-lg p-6 max-h-[60vh] overflow-y-auto">
            <div className="space-y-6 text-sm text-white">
              <section>
                <h3 className="text-lg font-semibold text-primary mb-3">1. Coleta de Dados</h3>
                <p className="mb-3">Coletamos as seguintes informações:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Nome, e-mail, telefone e data de nascimento</li>
                  <li>Histórico de transações e saldo de Tugas Coin</li>
                  <li>Dados de acesso (IP, localização, cookies)</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-primary mb-3">2. Finalidade do Uso dos Dados</h3>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Gerenciar sua conta e saldo de Tugas Coin</li>
                  <li>Enviar comunicações sobre promoções e novidades (com consentimento)</li>
                  <li>Garantir segurança e prevenir fraudes</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-primary mb-3">3. Compartilhamento de Dados</h3>
                <p className="mb-2">Seus dados <strong>não serão vendidos ou alugados</strong> a terceiros.</p>
                <p>Parceiros de pagamento ou operadoras de TI poderão processar dados sob contrato de confidencialidade.</p>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-primary mb-3">4. Direitos do Usuário</h3>
                <ul className="list-disc ml-6 space-y-2">
                  <li><strong>Acesso aos Dados:</strong> O usuário pode solicitar visualização dos dados armazenados.</li>
                  <li><strong>Retificação Limitada:</strong> Alterações nos dados cadastrais <strong>não são permitidas</strong> após o registro, exceto mediante comprovação em casos específicos.</li>
                  <li><strong>Exclusão de Conta:</strong> Contas serão automaticamente excluídas após <strong>24 meses de inatividade</strong>. Não é possível solicitar exclusão antecipada manualmente.</li>
                  <li><strong>Portabilidade de Dados:</strong> Pode solicitar cópia dos dados em formato legível.</li>
                  <li><strong>Revogação de Consentimento:</strong> Pode revogar consentimentos para marketing a qualquer momento.</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-primary mb-3">5. Segurança</h3>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Utilizamos criptografia para proteger transações e dados</li>
                  <li>Acesso restrito a funcionários autorizados</li>
                </ul>
              </section>

              <section>
                <h3 className="text-lg font-semibold text-primary mb-3">6. Contato</h3>
                <p className="mb-2">Dúvidas ou solicitações: adm2@mrtugas.com.br</p>
                <p>Atualizações desta política serão publicadas em nosso site.</p>
              </section>

              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mt-6">
                <p className="text-sm text-yellow-800 text-center mb-30">
                  <strong>Última atualização:</strong> {new Date().toLocaleDateString('pt-BR')}
                </p>
              </div>
            </div>
          </div>

          <div className="absolute justify-center mt-6 z-50">
            <Button
              tipo="primary"
                onClick={() => { navigate('/'); }}
              className="px-8 py-2"
            >
              Voltar
            </Button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default PoliticaPrivacidadePage;